// One entry per screen in the reporting dashboard design
// (fifopay-reporting-dashboard-alt.html at the repo root).
//
// Kept as its own file, same as every other module here, so a path is never
// typed as a string literal inside a component.
export default Object.freeze({
  // NOT a reporting screen: the main FifoPay dashboard, which the home button
  // in the top-left corner returns to. Listed here for the same reason as the
  // rest - so the path is never a string literal inside a component.
  FIFOPAY_DASHBOARD: "/dashboard",

  OVERVIEW: "/reporting",
  GENERAL: "/reporting/general",
  SALES: "/reporting/sales",
  OPERATIONS: "/reporting/operations",
  COLLECTIONS: "/reporting/collections",
  CLIENTS: "/reporting/clients",
  PARTNERS: "/reporting/partners",
  SETTINGS: "/reporting/settings",
});
